const SUBSCRIPTION_ID_KEY = "petterNativePushSubscriptionId";

function csrfToken() {
  const element = document.querySelector("meta[name='csrf-token']");
  return element ? element.content : "";
}

function dispatchResult(detail) {
  document.dispatchEvent(new CustomEvent("petter:native-push-registration-result", { detail: detail }));
}

async function registerToken(token, platform) {
  if (!token || !platform) {
    dispatchResult({ ok: false, error: "missing_token_or_platform" });
    return;
  }

  try {
    const response = await fetch("/push_subscriptions", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken(),
        "Accept": "application/json"
      },
      body: JSON.stringify({
        push_subscription: {
          token: token,
          platform: platform
        }
      })
    });
    const payload = await response.json();

    if (!response.ok) {
      dispatchResult({ ok: false, error: "registration_failed", status: response.status });
      return;
    }

    localStorage.setItem(SUBSCRIPTION_ID_KEY, payload.id);
    dispatchResult({ ok: true, id: payload.id, platform: payload.platform });
  } catch (_error) {
    dispatchResult({ ok: false, error: "network_error" });
  }
}

async function unregisterToken() {
  const subscriptionId = localStorage.getItem(SUBSCRIPTION_ID_KEY);
  if (!subscriptionId) return;

  try {
    const response = await fetch(`/push_subscriptions/${subscriptionId}`, {
      method: "DELETE",
      credentials: "same-origin",
      headers: {
        "X-CSRF-Token": csrfToken(),
        "Accept": "application/json"
      }
    });

    if (response.ok || response.status === 404) {
      localStorage.removeItem(SUBSCRIPTION_ID_KEY);
      dispatchResult({ ok: true, removed: true });
      return;
    }

    dispatchResult({ ok: false, error: "unregistration_failed", status: response.status });
  } catch (_error) {
    dispatchResult({ ok: false, error: "network_error" });
  }
}

document.addEventListener("petter:native-push-token", function (event) {
  const detail = event.detail || {};
  registerToken(detail.token, detail.platform);
});

window.PetterNativePush = {
  registerToken: registerToken,
  unregisterToken: unregisterToken
};
